import { useState } from 'react';
import { iconUrlFor } from './appIcons';
import { tileLetter } from './groupApps';

// Logo for a known app, letter tile otherwise. A failed image load is state
// (not a retry), so a blocked favicon service just settles on the letter.
export default function AppTile({ app }) {
  const url = iconUrlFor(app.display_text);
  const [failed, setFailed] = useState(false);
  return (
    <span className="ca-tile" aria-hidden="true">
      {url && !failed
        ? <img className="ca-tile__img" src={url} alt="" width="32" height="32" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
        : tileLetter(app)}
    </span>
  );
}
